import React, {ReactElement, useContext} from 'react';
import {useIntl} from 'react-intl';
import DeviceContext, {Device} from '../../../RootProvider/DeviceContext';
import LayoutSection, {LayoutBackground} from '../../DesignSystem/Layout/LayoutSection/LayoutSection';
import SectionTitleAndSubtitle from '../../DesignSystem/SectionTitleAndSubtitle/SectionTitleAndSubtitle';
import OurProductsLinks from './OurProductsLinks';
import OurProductsInformationBox from '../../DesignSystem/OurProductsInformationBox/OurProductsInformationBox';
import GetStartedButton from '../../DesignSystem/Buttons/GetStarted/GetStarted';

import './OurProducts.scss';
import {Alignment} from '../../../types';

function OurProducts(): ReactElement {
  const {formatMessage} = useIntl();
  const device = useContext(DeviceContext);
  const isMobile = device === Device.MOBILE;

  return (
    <LayoutSection type={LayoutBackground.WHITE} innerClassName="ourProducts">
      <SectionTitleAndSubtitle
        alignment={isMobile ? Alignment.LEFT : Alignment.CENTER}
        className="ourProducts__title"
        text={formatMessage({id: 'homepage.ourProducts.sectionTitleAndSubtitle.text'})}
        title={formatMessage({id: 'homepage.ourProducts.sectionTitleAndSubtitle.title'})}
      />
      <OurProductsLinks />
      <OurProductsInformationBox className="ourProductsInformationBox__homepage" />
      <div className="ourProducts__cta">
        <GetStartedButton />
      </div>
    </LayoutSection>
  );
}

export default OurProducts;
